/**
 * announcement-bar.js — Kawaicafe
 * Al pulsar una ciudad de la barra ([data-city-open="<blockId>"]) abre un modal
 * compartido ([data-city-modal]) y le inyecta el contenido del <template
 * data-city-content="<blockId>"> correspondiente. Cierre con la X, el overlay o Escape.
 */
(function () {
  'use strict';

  function getModal() {
    return document.querySelector('[data-city-modal]');
  }

  function openCity(blockId, color) {
    var modal = getModal();
    var tpl = document.querySelector('[data-city-content="' + blockId + '"]');
    if (!modal || !tpl) return;

    var content = modal.querySelector('[data-city-modal-content]');
    if (content) {
      content.innerHTML = '';
      content.appendChild(tpl.content.cloneNode(true));
    }

    if (color) {
      modal.style.setProperty('--kabm-accent', color);
    } else {
      modal.style.removeProperty('--kabm-accent');
    }

    modal.setAttribute('data-open', 'true');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.setAttribute('data-modal-open', 'true');
  }

  function closeCity() {
    var modal = getModal();
    if (!modal) return;
    modal.removeAttribute('data-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.removeAttribute('data-modal-open');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-city-open]');
    if (trigger) {
      event.preventDefault();
      openCity(trigger.getAttribute('data-city-open'), trigger.getAttribute('data-city-color'));
      return;
    }

    if (event.target.closest('[data-city-close]')) {
      event.preventDefault();
      closeCity();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCity();
  });

  // -------------------------------------------------------------------------
  // Marquesina (móvil): el track se mueve solo en bucle. Duplicamos el contenido
  // y medimos el desplazamiento EXACTO (offsetLeft del primer clon - del primer
  // original) para un loop sin saltos, y la duración para una velocidad cómoda
  // (~55px/s). Se pausa mientras se toca/pasa el ratón para poder pulsar una
  // ciudad. Solo <=989px; al pasar a desktop se desmonta (se quitan los clones).
  // -------------------------------------------------------------------------
  // Marquesina SIN HUECO (bucle real). Se construye el track como DOS mitades
  // exactamente iguales, cada una = la lista base repetida `perHalf` veces (con
  // un corazón separador tras cada repetición). La animación mueve translateX
  // de 0 a -50%: al ser -50% relativo al ANCHO PROPIO del track, mueve justo
  // una mitad y la segunda mitad cae exactamente donde estaba la primera → el
  // reinicio es invisible SEA CUAL SEA el ancho de la fuente (no dependemos de
  // medir píxeles, que era la causa del hueco al cargar Tutti Frutti). `perHalf`
  // garantiza que cada mitad llene al menos el ancho visible (si no, saldría un
  // hueco antes del salto).
  function initMarquee(track) {
    var mq = window.matchMedia('(max-width: 989px)');
    var bar = track.closest('.kawaii-ab__bar') || track;
    var baseNodes = Array.prototype.slice.call(track.children);
    var built = false;

    function clearClones() {
      var clones = track.querySelectorAll('.kab-clone');
      for (var i = 0; i < clones.length; i++) clones[i].parentNode.removeChild(clones[i]);
    }
    function build() {
      if (built || baseNodes.length === 0) return;
      clearClones();
      track.classList.add('is-marquee'); // width: max-content
      var baseWidth = track.scrollWidth; // solo la base (una copia de las ciudades)
      var container = bar.clientWidth || track.clientWidth || 360;
      // Copias por mitad para que cada mitad >= ancho visible.
      var perHalf = Math.max(1, Math.ceil((container + 32) / Math.max(1, baseWidth)));
      var units = perHalf * 2; // 2 mitades idénticas
      var sepTpl = track.querySelector('.kawaii-ab__sep');
      function appendSep() {
        if (!sepTpl) return;
        var s = sepTpl.cloneNode(true);
        s.classList.add('kab-clone');
        s.setAttribute('aria-hidden', 'true');
        track.appendChild(s);
      }
      function appendBase() {
        for (var i = 0; i < baseNodes.length; i++) {
          var c = baseNodes[i].cloneNode(true);
          c.classList.add('kab-clone');
          c.setAttribute('aria-hidden', 'true');
          if (c.tagName === 'BUTTON') c.tabIndex = -1;
          track.appendChild(c);
        }
      }
      // unidad 1 = base ya presente + corazón de cola; unidades 2..N = base + corazón.
      appendSep();
      for (var u = 2; u <= units; u++) { appendBase(); appendSep(); }
      // Duración desde el ancho de UNA mitad → velocidad lenta y cómoda (~26 px/s).
      var halfWidth = track.scrollWidth / 2;
      var SPEED = 26; // px/s (antes 55 → ahora bastante más lento)
      track.style.setProperty('--kab-marquee-dur', Math.max(14, halfWidth / SPEED) + 's');
      built = true;
    }
    function teardown() {
      if (!built) return;
      clearClones();
      track.classList.remove('is-marquee', 'is-paused');
      track.style.removeProperty('--kab-marquee-dur');
      built = false;
    }
    function update() { if (mq.matches) build(); else teardown(); }
    function recalc() { if (built) { teardown(); build(); } }

    function pause() { if (built) track.classList.add('is-paused'); }
    function resume() { track.classList.remove('is-paused'); }
    bar.addEventListener('pointerdown', pause);
    window.addEventListener('pointerup', resume);
    window.addEventListener('pointercancel', resume);
    bar.addEventListener('mouseenter', pause);
    bar.addEventListener('mouseleave', resume);

    if (mq.addEventListener) mq.addEventListener('change', update);
    else if (mq.addListener) mq.addListener(update);
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(recalc, 200); });
    // La seamlessness NO depende de medir la fuente (es -50%), pero recalculamos
    // perHalf/duración cuando cargue Tutti Frutti y en load por si cambió el ancho.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(recalc);
    }
    window.addEventListener('load', recalc);
    update();
  }

  function bootMarquee() {
    var tracks = document.querySelectorAll('.kawaii-ab__track');
    for (var i = 0; i < tracks.length; i++) initMarquee(tracks[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootMarquee);
  else bootMarquee();
})();
